export const environment = {
  production: false,
  name: 'stage'
};
